import { neueBestellungOeffnen } from '@/lib/neueBestellung';
import { Link, useNavigate } from '@tanstack/react-router';
import { Archive, LayoutDashboard, Plus } from 'lucide-react';
import { Glocke } from './Glocke';
import { MobilMenue } from './MobilMenue';
import { FOKUS_RING } from '@/lib/fokus';

// Die Bottom-Navigation für Telefone.
//
// Fünf Ziele: die Liste, das Archiv, das Anlegen, die Glocke, das Menü.
// Sie liegt fest am unteren Rand, weil dort der Daumen ist — eine
// Seitenspalte auf einem Telefon bedeutet, mit der zweiten Hand
// nachzuhelfen.
//
// Das Archiv kam mit A10.4 dazu. Fünf ist die Grenze: jedes Ziel hält
// weiterhin 56 × 56 Pixel, darunter trifft man sie im Vorbeigehen nicht
// mehr. Ein sechstes müsste ins Menü.
//
// Die Sicherheitszone des Home-Indikators (iOS) wird als Polsterung unten
// angehängt; `viewport-fit=cover` in index.html macht env() überhaupt erst
// wirksam. Ohne beides liegt der Wischbalken auf den Knöpfen.
//
// Die Leiste ist NICHT `fixed`, sondern das letzte Kind der Bildschirm-
// spalte in PageLayout — gescrollt wird im <main> darüber. Warum das die
// bessere Wahl ist, steht dort.

export function BottomNav() {
  const navigate = useNavigate();

  return (
    <nav
      aria-label="Hauptnavigation"
      data-tour="bottom-nav"
      className="z-40 flex shrink-0 items-stretch gap-1 border-t border-line bg-cream px-2 pb-[env(safe-area-inset-bottom)] pt-1"
    >
      <Link
        to="/"
        activeOptions={{ exact: true }}
        className="flex min-h-[56px] min-w-[56px] flex-1 flex-col items-center justify-center gap-0.5 rounded-md px-2 py-1 text-ink-soft hover:bg-cream-dark hover:text-akzent"
        activeProps={{ className: 'text-akzent' }}
      >
        <LayoutDashboard className="h-6 w-6" />
        <span className="text-[0.65rem] leading-none">Dashboard</span>
      </Link>

      <Link
        to="/archiv"
        className="flex min-h-[56px] min-w-[56px] flex-1 flex-col items-center justify-center gap-0.5 rounded-md px-2 py-1 text-ink-soft hover:bg-cream-dark hover:text-akzent"
        activeProps={{ className: 'text-akzent' }}
      >
        <Archive className="h-6 w-6" />
        <span className="text-[0.65rem] leading-none">Archiv</span>
      </Link>

      <button
        type="button"
        data-tour="neue-bestellung"
        // Sichtbar „Neu", vorgelesen „Neue Bestellung": in der Leiste ist
        // für das ganze Wort kein Platz, im Screenreader schon.
        aria-label="Neue Bestellung"
        onClick={() => {
          // TanStack Router cross-route Search-Reducer kann typseitig
          // nicht aufgeloest werden — siehe Sidebar.
          neueBestellungOeffnen(navigate as never);
        }}
        className={`flex min-h-[56px] min-w-[56px] flex-1 flex-col items-center justify-center gap-0.5 rounded-md px-2 py-1 text-akzent hover:bg-cream-dark ${FOKUS_RING}`}
      >
        <Plus className="h-6 w-6" />
        <span className="text-[0.65rem] leading-none">Neu</span>
      </button>

      <Glocke variante="leiste" />
      <MobilMenue />
    </nav>
  );
}
